import { ChartConfig } from "@/core/components/ui/chart";

export const INSIGHTS_CLASSES: Record<string, string> = {
  identified_growth: "border-green-500 bg-green-50 text-green-700",
  geographic_expansion: "border-blue-500 bg-blue-50 text-blue-700",
  improvement_opportunity: "border-orange-500 bg-orange-50 text-orange-700",
  type_preference: "border-purple-500 bg-purple-50 text-purple-700",
  default: "border-gray-500 bg-gray-50 text-gray-700",
};

export const INSIGHTS_TITLES: Record<string, string> = {
  identified_growth: "report-viewer-insights-list-identified-growth",
  geographic_expansion: "report-viewer-insights-list-geographic-expansion",
  improvement_opportunity:
    "report-viewer-insights-list-improvement-opportunity",
  type_preference: "report-viewer-insights-list-type-preference",
  default: "report-viewer-insights-list-default",
};

export const INSIGHTS_SERIES_COLORS = {
  blue600: "#2563eb",
  blue500: "#3b82f6",
  green600: "#16a34a",
  slate400: "#94a3b8",
  red600: "#dc2626",
  orange500: "#f97316",
  purple600: "#7c3aed",
  gray500: "#6b7280",
  mrColor: "#c6b5e8",
  wsColor: "#f9e10b",
  poColor: "#cadb66",
  eeColor: "#ffa929",
  evColor: "#f39bab",
  poondemandColor: "#839900",
  mreeColor: "#6839c7",
} as const;

export const INSIGHTS_PIE_SERIES_FALLBACK = [
  INSIGHTS_SERIES_COLORS.blue600,
  INSIGHTS_SERIES_COLORS.green600,
  "#0891b2",
  "#ea580c",
  "#8b5cf6",
];

export const configs: ChartConfig = {
  desktop: {
    label: "Desktop",
    color: INSIGHTS_SERIES_COLORS.blue600,
  },
  mobile: {
    label: "Mobile",
    color: INSIGHTS_SERIES_COLORS.blue500,
  },
};

export const typesColors: Record<string, string> = {
  MR: INSIGHTS_SERIES_COLORS.mrColor,
  WS: INSIGHTS_SERIES_COLORS.wsColor,
  PO: INSIGHTS_SERIES_COLORS.poColor,
  EE: INSIGHTS_SERIES_COLORS.eeColor,
  EV: INSIGHTS_SERIES_COLORS.evColor,
  PO_ON_DEMAND: INSIGHTS_SERIES_COLORS.poondemandColor,
  MR_EE: INSIGHTS_SERIES_COLORS.mreeColor,
};

export const HEADER_ITEMS_EXPORT = [
  "utilization-bookings-export-header-date",
  "utilization-bookings-export-header-time",
  "utilization-bookings-export-header-package-id",
  "utilization-bookings-export-header-status",
  "utilization-bookings-export-header-checkin",
  "utilization-bookings-export-header-credits",
  "utilization-bookings-export-header-name",
  "utilization-bookings-export-header-document",
  "utilization-bookings-export-header-email",
  "utilization-bookings-export-header-group",
  "utilization-bookings-export-header-department",
  "utilization-bookings-export-header-sub-department",
  "utilization-bookings-export-header-type",
  "utilization-bookings-export-header-space",
  "utilization-bookings-export-header-room-name",
  "utilization-bookings-export-header-reserved",
  "utilization-bookings-export-header-city",
  "utilization-bookings-export-header-neighborhood",
  "utilization-bookings-export-header-participants",
  "utilization-bookings-export-header-guest",
  "utilization-bookings-export-header-reservation-id",
  "utilization-bookings-export-header-created-booking",
  "utilization-bookings-export-header-booking-reason",
];
